<template>
  <div>
    <!--TOOLBAR-->
    <tool-bar title="Copy Service Log" />
    <!--CONTAINER VIEW-->
    <v-container
      class="page-container"
      :class="{'mobile pa-4': isMobile, 'py-4 px-5': isTablet}">
      <student-card :student="student" />
      <service-log-form
        :showTooltip="showTooltip"
        :student="student"
        :loadData="loadData"
        :medicaidArray="medicaidArray"
        :absentTypesArray="absentTypesArray"
        :absentReasonsArray="absentReasonsArray"
        :absentAlternativesArray="absentAlternativesArray"
        :groupTypeArray="groupTypeArray"
        :deliveryModeArray="deliveryModeArray"
        :serviceDeliveredArray="serviceDeliveredArray"
        :index="1"
        :arrayLength="1"
        action="copy"
        v-on:form:submitted="submitted = true"
      />
    </v-container>
    <full-screen-loading-spinner v-if="showLoading" />
    <bottom-nav />
  </div>
</template>

<script>
import Vue from 'vue';
import * as _ from 'lodash';
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import Toolbar from '@/components/toolbar';
import api from '@/utils/api';
import ServiceLogForm from '@/components/service-log/form/service-log-form';
import StudentCard from '@/components/service-log/form/student-card';
import BottomNav from '@/components/bottom-nav';
import utilityFunctions from '@/utils/functions';
import StudentClass from '@/utils/student-class';
import ServiceLogClass from '@/utils/service-log-class';
import FullScreenLoadingSpinner from '@/components/full-screen-loading-spinner';
import * as Constants from '@/constants';

export default {
  components: {
    ServiceLogForm,
    Toolbar,
    StudentCard,
    BottomNav,
    FullScreenLoadingSpinner
  },
  name: 'SlCopy',
  data() {
    return {
      showLoading: false,
      submissionData: null,
      student: null,
      loadData: false,
      medicaidArray: null,
      absentTypesArray: null,
      absentReasonsArray: null,
      absentAlternativesArray: null,
      groupTypeArray: null,
      deliveryModeArray: null,
      serviceDeliveredArray: null,
      submitted: false
    };
  },
  computed: {
    ...mapGetters({
      showTooltip: 'showTooltip'
    }),
    isMobile() {
      return this.$mq === 'mobile';
    },
    isTablet() {
      return this.$mq === 'tablet';
    }
  },
  methods: {
    hasServiceInformationChanged() {
      return !_.isEqual(Vue.prototype.$savedData.serviceInformation, this.student.form.serviceInformation);
    },
    hasMedicaidInformationChanged() {
      return !_.isEqual(Vue.prototype.$savedData.medicaid, this.student.form.medicaid);
    },
    hasInformationChanged() {
      return this.hasServiceInformationChanged() || this.hasMedicaidInformationChanged();
    }
  },
  created() {
    utilityFunctions.clearSubmissionArray();
    const sessionId = this.$route.params.sessionId;
    this.showLoading = true;
    let data;
    Promise.all([
      api.get(Constants.PTSL_GET_PT_SESSION_URL(sessionId)),
      api.get(Constants.GET_MEDICAID_PROCEDURES_LIST_URL()),
      api.get(Constants.ABSENT_TYPES_URL()),
      api.get(Constants.ABSENT_REASONS_URL()),
      api.get(Constants.ABSENT_ALTERNATIVES_URL()),
      api.get(Constants.GROUP_TYPES_URL()),
      api.get(Constants.DELIVERY_MODES_URL()),
      api.get(Constants.SERVICE_DELIVERED_URL())
    ])
      .then((submission) => {
        data = submission[0].data.data;
        // set medicaid procedures array
        this.medicaidArray = submission[1].data.data;
        // set absentTypesArray
        this.absentTypesArray = submission[2].data.data;
        // set absentReasonsArray
        this.absentReasonsArray = submission[3].data.data;
        // set absentAlternativesArray
        this.absentAlternativesArray = submission[4].data.data;
        // set groupTypeArray
        this.groupTypeArray = submission[5].data.data;
        // set deliveryModeArray
        this.deliveryModeArray = submission[6].data.data;
        // set serviceDeliveredArray
        this.serviceDeliveredArray = submission[7].data.data;
        return api.get(Constants.GET_SERVICE_LOCATIONS_URL(data.locationName));
      })
      .then((school) => {
        data.location = school.data.data[0];
        // need to use vue.set to make the information reactive
        Vue.set(this, 'student', new StudentClass(data));
        const info = new ServiceLogClass(data, false, true);
        // save initialized form data to check if data changed before navigating away
        Vue.prototype.$savedData = _.cloneDeep(info);
        // need to use vue.set to make the information reactive
        Vue.set(this.student, 'form', info);
      })
      .finally(() => {
        this.loadData = true;
        this.showLoading = false;
      });
  },
  beforeRouteLeave(to, from, next) {
    if (!this.submitted) {
      if (this.hasInformationChanged()) {
        Swal.fire({
          text: 'You have unsaved information.  Are you sure you want to leave this page?',
          confirmButtonText: 'OK',
          showCancelButton: true,
          customClass: {
            popup: 'popup-class',
            content: 'content-class',
            confirmButton: 'confirm-button-class'
          }
        }).then((response) => {
          // if ok was clicked
          if (response && response.value) {
            next();
          }
        });
      } else {
        next();
      }
    } else {
      next();
    }
  }
};
</script>

<style lang="scss" scoped />



// WEBPACK FOOTER //
// src/views/service-log/copy-service-log.vue